import Vue from 'vue'
import App from './App.vue'
import GmapVue from 'gmap-vue'
import { components } from 'gmap-vue';
import panZoom from 'vue-panzoom'

Vue.config.productionTip = false

Vue.use(GmapVue,{
  load: {
    key: 'AIzaSyB1aX0Ss-xisZEtUnBwyvfiU_zgzQyIP30',
    libraries: 'places',
  },
  installComponents: true,
});
Vue.use(panZoom);
Vue.component('gmap-cluster', components.Cluster);
new Vue({
  render: h => h(App),
}).$mount('#app')
